export { default as SolutionsHero } from './SolutionsHero';
